module.exports = __webpack_public_path__ + "static/media/exclusion manager.ac04d5e5.svg";